import React from 'react';
import styles from './AppointmentOrderComplete.module.scss';
import moment from 'moment/moment';

export default function AppointmentOrderComplete({ order }) {
  return (
    <div>
      {order
        .cart
        .orderPackages
        .filter((orderPackage) => !!orderPackage.appointmentTime)
        .map((orderPackage) => {
          const portraitType = orderPackage.student.grade === '12' ? 'senior portraits' : 'portraits';
          const momentTime = moment(orderPackage.appointmentTime);
          const isDST = momentTime.isDST();
          const offset = isDST ? '-07:00' : '-08:00';
          const appointmentDate = orderPackage.appointmentTime.replace('+00:00', offset);
          const app_hour = parseInt(appointmentDate.split(" ")[1].split(":")[0])
          const AM_PM = app_hour >= 12 ? 'PM' : 'AM'
          // 1. Create a moment object from the original valid date string
          //    moment.utc() tells Moment.js to interpret the string as UTC and keep it in UTC.
          const appointmentMomentUTC = moment.utc(orderPackage.appointmentTime);

          // 2. Format directly from the UTC moment object
          //    No need for .tz() or .local() if you want to display in UTC.
          const displayDate = appointmentMomentUTC.format('MMMM DD, YYYY');
          const displayTime = appointmentMomentUTC.format('h:mm A'); // Example: "3:30 PM"
          // You might also want to explicitly add "UTC" to the display time
          const displayTimeWithUTC = appointmentMomentUTC.format('h:mm A [UTC]'); // Example: "3:30 PM UTC"


          return (
            <div className={styles.container}>
              <h1>{`${orderPackage.student.firstName}'s ${portraitType} appointment is booked!`}</h1>
              <p className={styles.milestoneMsg}>We look forward to capturing this milestone!</p>

              <p className={styles.bold}>{`${orderPackage.student.firstName} ${orderPackage.student.lastName}`}</p>
              <p>Date: <span className={styles.bold}>{displayDate}</span></p>
              <p>Time: <span>{displayTime}</span></p>
              <p>Location: <span className={styles.bold}>{orderPackage.schoolId == 1075 ? 'Shoob Studio 4640 Spyres Way #1, Modesto, CA' : orderPackage.student.school.scheduleLocation}</span></p>
              <p>Session: <span className={styles.bold}>{orderPackage.apiOption.name}</span></p>
            </div>
          );
        })
      }
    </div>
  );
}
